/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type AttachmentEntityTypeEnum = "contacts" | "containers" | "messages" | "shipments" | "%future added value";
export type infoUploadAttachmentsToEntityInput = {
    clientMutationId?: string | null;
    entityType: AttachmentEntityTypeEnum;
    entitySlug: string;
    attachments: Array<EntityAttachmentArgument>;
};
export type EntityAttachmentArgument = {
    identifier: string;
    name: string;
    documentType?: string | null;
    folderSlug: string;
};
export type FileCreationDialogUploadMutationVariables = {
    input: infoUploadAttachmentsToEntityInput;
};
export type FileCreationDialogUploadMutationResponse = {
    readonly infoUploadAttachmentsToEntity: {
        readonly clientMutationId: string | null;
    } | null;
};
export type FileCreationDialogUploadMutation = {
    readonly response: FileCreationDialogUploadMutationResponse;
    readonly variables: FileCreationDialogUploadMutationVariables;
};



/*
mutation FileCreationDialogUploadMutation(
  $input: infoUploadAttachmentsToEntityInput!
) {
  infoUploadAttachmentsToEntity(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoUploadAttachmentsToEntityPayload",
    "kind": "LinkedField",
    "name": "infoUploadAttachmentsToEntity",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FileCreationDialogUploadMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FileCreationDialogUploadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2decb61d68834b65a014b85c4c9c12b9",
    "id": null,
    "metadata": {},
    "name": "FileCreationDialogUploadMutation",
    "operationKind": "mutation",
    "text": "mutation FileCreationDialogUploadMutation(\n  $input: infoUploadAttachmentsToEntityInput!\n) {\n  infoUploadAttachmentsToEntity(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f82f1fd184acc6c0793482ecdb331f49';
export default node;
